import React from 'react';
import { Link } from 'react-router-dom';

const listenOnNav = (e) => {
  const navs = document.getElementsByClassName('nav-item');
  for (let i = 0; i < navs.length; i++) {
    navs[i].classList.remove('active');
  }
};

const UnauthenticatedNav = () => {
  return (
    <span>
      <nav className="navbar navbar-light d-flex d-md-none">
        <Link to="/" className="navbar-brand">
          <img src="images/GhanWifi Logo.png" alt="GhanaWifi Logo" />
        </Link>

        <div className="dropdown">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent1"
            aria-controls="navbarSupportedContent1"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars" />
          </button>

          <div
            className="navbar-collapse collapse dd pt-4"
            id="navbarSupportedContent1"
          >
            <Link target="_self" to="/" className="dropdown-item">
              Overview
            </Link>
          </div>
        </div>
      </nav>

      <nav className="navbar navbar-expand-lg navbar-light bg-ligh d-none d-md-flex">
        <Link className="navbar-brand mr-5" to="/">
          <img src="images/GhanWifi Logo.png" alt="GhanaWifi Logo" />
        </Link>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav col-md-10 mt-2">
            <li
              className="nav-item"
              onClick={(e) => {
                listenOnNav(e.target);
              }}
            >
              <Link className="nav-link" to="/" target="_self">
                <i className="fas fa-home" />
                Overview
                <span className="sr-only">(current)</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <br />
    </span>
  );
};

export default UnauthenticatedNav;
